import React from "react";
import { Spinner as Spinners } from "@chakra-ui/react";
import { theme } from "src/styles/theme";

interface ISpinner {
  size?: string;
}

const Spinner = ({ size = undefined }: ISpinner) => {
  return <Spinners color={theme.primary} size={size} />;
};

export default Spinner;
